<template lang="pug">
div.mylist--history
  ul.mylist--history-list
    li.mylist--history-item(v-for="myListRelatedHistory in myListRelatedHistories" :key="myListRelatedHistory.id")
      span.mylist--history-date
        | {{myListRelatedHistory.text_of_time_ago}}
      template(v-if="myListRelatedHistory.target_type == 'MyList'")
        template(v-if="myListRelatedHistory.history_type == 'create'")
          template(v-if="myListRelatedHistory.my_list_is_deleted")
            p.mylist--history-deleted
              | {{myListRelatedHistory.my_list_name}}
            | を作成
          template(v-else)
            span.mylist--history-show(@click="setMyListId(myListRelatedHistory.my_list_id)")
              | {{myListRelatedHistory.my_list_name}}
            | を作成
        template(v-else)
          p.mylist--history-deleted
            | {{myListRelatedHistory.my_list_name}}
          | を削除
      template(v-else)
        // MyListElementは追加時の履歴しか残していない
        a.mylist--history-link(:href="myListRelatedHistory.path" target="_blank")
          | {{myListRelatedHistory.listable_name}}
        | を
        span.mylist--history-show(@click="setMyListId(myListRelatedHistory.my_list_id)")
          | {{myListRelatedHistory.my_list_name}}
        | に追加

  infinite-loading(spinner="waveDots" @infinite="infiniteHandler" :identifier="infiniteIdForHistory" ref="infiniteLoading")
    span(slot="no-results")
    span(slot="no-more")
  button.mylist--history-back(@click="$emit('view-index-my-list-page')")
    i.font-awesome-icon(class="fa fa-angle-left")
    | 一覧に戻る
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
  components: { InfiniteLoading },
  props: {
    friendId: {
      type: Number,
      default: 0
    },
    myListRelatedHistories: {
      type: Array,
      default: () => ([])
    },
    infiniteIdForHistory: {
      type: Number,
      default: 0
    }
  },
  mounted: function() {
    this.infiniteHandler(this.$refs.infiniteLoading.stateChanger);
  },
  methods: {
    setMyListId: function(myListId) {
      this.$emit('set-my-list-id', myListId);
    },
    infiniteHandler: function($state) {
      this.$emit('index-my-list-related-history', $state);
    }
  }
};
</script>
